import { Button } from "../ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "../ui/dialog";
import { PosizioneFrigoSelect } from "./PosizioneFrigoSelect";

export const LottoPositionForm = ({ lotto, prodottoNome, value, onChange, onClose, onSave, saving, frigoriferi, posizioni }) => (
  <>
    <DialogHeader>
      <DialogTitle>Modifica posizione</DialogTitle>
      <DialogDescription data-testid="lotto-posizione-nome">{prodottoNome || lotto?.nome_prodotto || "Lotto"}</DialogDescription>
    </DialogHeader>
    <PosizioneFrigoSelect value={value} onChange={onChange} frigoriferi={frigoriferi}
      posizioniLegacy={posizioni} testId="lotto-archiviato-posizione" />
    <DialogFooter className="gap-2">
      <Button type="button" variant="outline" onClick={onClose} disabled={saving} data-testid="lotto-posizione-annulla">Annulla</Button>
      <Button type="button" onClick={onSave} disabled={saving} data-testid="lotto-posizione-salva">
        {saving ? "Salvataggio..." : "Salva posizione"}
      </Button>
    </DialogFooter>
  </>
);

export const LottoPositionDialog = ({ lotto, value, onChange, onClose, onSave, saving, frigoriferi, posizioni }) => (
  <Dialog open={!!lotto} onOpenChange={open => !open && !saving && onClose()}>
    <DialogContent className="max-w-md" data-testid="lotto-posizione-dialog">
      <LottoPositionForm lotto={lotto} value={value} onChange={onChange} onClose={onClose}
        onSave={onSave} saving={saving} frigoriferi={frigoriferi} posizioni={posizioni} />
    </DialogContent>
  </Dialog>
);